import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Info } from "../../models/user.interface";
import { AuthenticationService } from "../../services/authentication.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./default-layout.component.html",
  styleUrls: ["./default-layout.component.css"],
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems: any;
  user: Info;
  fecha: any;
  tipoCambio: any;
  tipoCambioCompra: any;
  tipoCambioVenta: any;

  constructor(private auth: AuthenticationService, private srvRoute: Router) {
    try {
      if (
        localStorage.getItem("init") === undefined ||
        localStorage.getItem("init") === null
      ) {
      } else {
        localStorage.removeItem("init");
        window.location.reload();
      }
    } catch (err) {
      console.log("Error controlado - continua navegando");
    }
  }

  cargarPerfil() {
    this.user = this.auth.currentUserValue[0];

    const menu = this.auth.currentMenuValue;

    this.navItems = menu.map((parent, index) => ({
      ...parent,
      class: `menu-parent menu-parent-${index}`,
      children: parent.children?.map((child) => ({
        ...child,
        class: `menu-child menu-child-${index}`,
      })),
    }));
  }

  toggleMinimize(e: any) {
    this.sidebarMinimized = e;
  }

  logout() {
    this.srvRoute.navigateByUrl("logout-system");
    window.location.href = "https://www.crecosa.com";
  }

  cargarParametros() {
    this.auth.cargarParametros().subscribe((res: any) => {
      this.fecha = res.data.fechaLnCredito;
      this.tipoCambio = res.data.tipoCambioOficial;
      this.tipoCambioCompra = res.data.tipoCambioCompra;
      this.tipoCambioVenta = res.data.tipoCambioVenta;
    });
  }

  cargarVariables() {
    this.auth.cargarVariableActuales().subscribe((res) => {});
  }

  ngOnInit() {
    // Si vienes del logion aqui es donde se continua
    this.cargarPerfil();
    this.cargarParametros();
    this.cargarVariables();
  }
}
